"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteStylesObserver = void 0;
const useMutationObserver_1 = require("../useMutationObserver/useMutationObserver");
const SITE_STYLES_ID = 'SITE_STYLES';
const useSiteStylesObserver = (props) => (0, useMutationObserver_1.useMutationObserver)(Object.assign(Object.assign({}, props), { options: { childList: true }, element: document.getElementById(SITE_STYLES_ID) }));
exports.useSiteStylesObserver = useSiteStylesObserver;
//# sourceMappingURL=useSiteStylesObserver.js.map